import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["align", "animate", "children", "onOpenStart", "onOpenComplete", "onCloseStart", "onCloseComplete", "open", "panelKey", "rootNode"];
let _ = t => t,
  _t;
import { Fragment } from 'react';
import styled, { ThemeProvider, createGlobalStyle, useTheme } from 'styled-components';
import MobileLayer from './MobileLayer';
import MobilePanelTransition from './internal/MobilePanelTransition';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobilePanelGlobalStyle = createGlobalStyle(_t || (_t = _`
  #hubspot-messages-iframe-container {
    z-index: 0 !important;
  }
  body {
    top: ${0};
  }
`), `-${window.scrollY}px`);
const StyledPanelWrapper = styled.div.withConfig({
  displayName: "MobilePanel__StyledPanelWrapper",
  componentId: "sc-1bnsh89-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    display: 'flex',
    flexDirection: 'row',
    paddingBlockStart: theme.space['600'],
    background: theme.color['fill-surface-default'],
    overflowX: 'hidden',
    overflowY: 'auto',
    zIndex: 1211
  };
});
const StyledPanelInner = styled.div.withConfig({
  displayName: "MobilePanel__StyledPanelInner",
  componentId: "sc-1bnsh89-1"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    display: 'flex',
    flexDirection: 'column',
    paddingBlockStart: theme.space['400'],
    minHeight: '100%',
    width: '100%'
  };
});
const MobilePanel = _ref => {
  let {
      align = 'right',
      animate = true,
      children,
      onOpenStart,
      onOpenComplete,
      onCloseStart,
      onCloseComplete,
      open,
      rootNode
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const renderedPanel = /*#__PURE__*/_jsx(ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/_jsx(StyledPanelWrapper, Object.assign({}, rest, {
      children: /*#__PURE__*/_jsx(StyledPanelInner, {
        children: children
      })
    }))
  });
  return open ? /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MobilePanelGlobalStyle, {}), /*#__PURE__*/_jsx(MobileLayer, {
      rootNode: rootNode,
      Transition: MobilePanelTransition,
      transitionProps: {
        onOpenStart,
        onOpenComplete,
        onCloseStart,
        onCloseComplete,
        align,
        animate
      },
      children: renderedPanel
    })]
  }) : null;
};
export default MobilePanel;